module.exports = __webpack_public_path__ + "static/img/icon-facebook.b889182d.png";